import debounce from 'lodash/debounce';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import {combineReducers} from 'redux';

import {apiUpdateInspection} from '../inspection/inspection.actions';
import * as InspectionActionTypes from '../inspection/inspection.actionTypes';

const byId = (state = {}, action) => {
  if (action.response && action.response.entities &&
      action.response.entities.formData) {
    if (action.response.method && action.response.method === 'DELETE') {
      return omit(state, keys(action.response.entities.formData));
      }
    return merge({}, state, action.response.entities.formData);
  } else if (
      action.payload && action.payload.entities &&
      action.payload.entities.formData && action.type !== 'persist/REHYDRATE') {
    if (action.payload.method && action.payload.method === 'DELETE') {
      return omit(state, keys(action.payload.entities.formData));
      }
    let formData = action.payload.entities.formData;
    if (action.meta && action.meta.tempId) {
      formData = {
        [action.payload.result]:
            merge(
                {}, state[action.meta.tempId],
                action.payload.entities.formData[action.payload.result]),
      };
      }
    const mergedData = merge({}, state, formData);
    if (action.type === InspectionActionTypes.CREATE_INSPECTION_SUCCESS) {
      if (action.meta.dispatch) {
        debounce(() => {
          action.meta.dispatch(apiUpdateInspection(
              {formData: mergedData[action.payload.result]}));
        })();
      }
      }

    return mergedData;
    }
  switch (action.type) {
    case InspectionActionTypes.GENERATE_INSPECTION_ID: {
      const newState = {
        ...state,
        [action.id]: {
          _id: action.id,
          createdBy: {name: ''},
        },
      };
      return newState;
      }
    case InspectionActionTypes.UPDATE_GENERATED_INSPECTION: {
      return merge({}, state, action.data);
      }
    // Optimistically update inspection locally and correct with server response
    case InspectionActionTypes.UPDATE_INSPECTION_REQUEST:
      const data = action.payload.data;
      const newState = {
        ...state,
        [data.formData._id]: {...data.formData},
      };
      return newState;
    default:
      return state;
  }
};

const reducer = combineReducers({
  byId,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/formData/formData.reducer.js